<script>
import Frontend from "./frontend/Frontend.vue";

export default {
  name: "App",
  components: {Frontend}
}
</script>

<template>
  <Frontend>
    <router-view></router-view>
  </Frontend>
</template>
